<section class="not-found-page" aria-labelledby="not-found-title">
  <div class="not-found-content">
    <article class="not-found-card">
      <div class="status-bar"></div>

      <div class="card-body">
        <!-- Logo ZIVO -->
        <div class="brand-wrapper">
          <img
            src="assets/img/Zivo_only_logo.png"
            alt="ZIVO ERP"
            class="zivo-logo"
          />
        </div>

        <!-- Código 404 -->
        <div class="error-number" aria-hidden="true">
          <span>4</span>

          <div class="error-zero">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="11"
                cy="11"
                r="6.5"
                stroke="currentColor"
                stroke-width="1.7"
              />

              <path
                d="M16 16L21 21"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
              />
            </svg>
          </div>

          <span>4</span>
        </div>

        <span class="error-code"> ERROR 404 </span>

        <h1 id="not-found-title">Página no encontrada</h1>

        <p class="description">
          La página que estás buscando no existe, fue movida o la dirección
          ingresada no es correcta.
        </p>

        <p class="help-text">
          Puedes cerrar a la página o continuar desde el inicio de
          ZIVO ERP.
        </p>

        <div class="divider"></div>

        <div class="actions">
          <button type="button" class="btn btn-primary" (click)="irLogin()">
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M14 8L18 12L14 16"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

              <path
                d="M18 12H8"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
              />

              <path
                d="M11 5H6.5C5.67 5 5 5.67 5 6.5V17.5C5 18.33 5.67 19 6.5 19H11"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
              />
            </svg>

            Volver al login
          </button>

          <button
            type="button"
            class="btn btn-secondary"
            (click)="cerrarPestana()"
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M6 6L18 18"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
              />

              <path
                d="M18 6L6 18"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
              />
            </svg>

            Cerrar pestaña
          </button>
        </div>
      </div>
    </article>

    <footer class="not-found-footer">
      <span>© {{ anioActual }} NOVAX</span>

      <span class="footer-dot"></span>

      <span>ZIVO ERP</span>

      <span class="footer-dot"></span>

      <span>Departamento de TI</span>
    </footer>
  </div>
</section>
